import { CSSProperties } from 'react';

export function useCSSVariables(
  variables: Record<string, string | number | undefined>
): CSSProperties {
  const mappedVariables: Record<string, string | number> = {};

  Object.entries(variables).forEach(([key, value]) => {
    if (value === undefined) return;
    mappedVariables[`--${key}`] = value;
  });

  return mappedVariables as CSSProperties;
}
